import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import App from './App';
import Home from './pages/Home';
import BlogList from './pages/BlogList';
import BlogDetail from './pages/BlogDetail';
import Offerings from './pages/Offerings';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Register from './pages/Register';
import AdminDashboard from './pages/AdminDashboard';
import Careers from './pages/Careers';
import JobDetails from './pages/JobDetails';
import About from './pages/About';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import WhyTalyfax from './pages/WhyTalyfax';


const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Home /> }, // ✅ root now loads Home
      { path: 'about', element: <About /> },
      { path: 'blogs', element: <BlogList /> },
      { path: 'blog/:slug', element: <BlogDetail /> },
      { path: 'offerings', element: <Offerings /> },
      { path: 'portfolio', element: <Portfolio /> },
      { path: 'contact', element: <Contact /> },
      { path: 'login', element: <Login /> },
      { path: 'register', element: <Register /> },
      { path: 'forgot-password', element: <ForgotPassword /> }, 
      { path: 'reset-password', element: <ResetPassword /> },
      { path: 'admin', element: <AdminDashboard /> },
      { path: 'careers', element: <Careers /> },
      { path: 'careers/:id', element: <JobDetails /> },
      { path: 'why-talyfax', element: <WhyTalyfax /> },
    ],
  },
]);

export default router;
